import { Skeleton } from '@/components/ui/skeleton';

export const AgendaSkeleton = () => {
  return (
    <>
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="space-y-2">
          <Skeleton className="h-8 w-32" />
          <Skeleton className="h-4 w-64" />
        </div>
      </div>

      {/* Filters */}
      <div className="flex flex-wrap gap-4">
        <Skeleton className="h-10 w-48" />
        <Skeleton className="h-10 w-32" />
      </div>

      {/* Summary Cards */}
      <div className="grid md:grid-cols-3 responsive-grid-gap">
        {[1, 2, 3].map((i) => (
          <div key={i} className="rounded-lg border border-border bg-card p-4 space-y-2">
            <div className="flex items-center gap-2">
              <Skeleton className="h-5 w-5" />
              <Skeleton className="h-4 w-24" />
            </div>
            <Skeleton className="h-7 w-32" />
          </div>
        ))}
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 lg:grid-cols-3 responsive-grid-gap">
        {/* Calendar */}
        <div className="bg-card rounded-xl p-4 sm:p-6 shadow-sm border border-border">
          <Skeleton className="h-6 w-32 mb-4" />
          <div className="grid grid-cols-7 gap-1">
            {/* Day headers */}
            {[1, 2, 3, 4, 5, 6, 7].map((i) => (
              <Skeleton key={`header-${i}`} className="h-8 w-full" />
            ))}
            {/* Calendar days */}
            {[...Array(35)].map((_, i) => (
              <Skeleton key={i} className="h-10 w-full" />
            ))}
          </div>
        </div>

        {/* Agenda Items */}
        <div className="lg:col-span-2 panel-gap">
          <Skeleton className="h-6 w-48" />
          <div className="list-gap">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
              <div key={i} className="bg-card rounded-lg p-4 border border-border flex items-center justify-between">
                <div className="flex items-center gap-4">
                  <Skeleton className="h-10 w-10 rounded-lg" />
                  <div className="space-y-2">
                    <Skeleton className="h-4 w-48" />
                    <Skeleton className="h-3 w-32" />
                  </div>
                </div>
                <div className="text-right space-y-2">
                  <Skeleton className="h-4 w-24" />
                  <Skeleton className="h-3 w-16" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
